import { render, staticRenderFns } from "./CustomerTag.vue?vue&type=template&id=0e3db898&"
import script from "./CustomerTag.vue?vue&type=script&lang=ts&"
export * from "./CustomerTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports